import React, { useEffect, useState, useMemo, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-quartz.css';
import 'ag-grid-enterprise';
import './HomePage.css'
import ToolsRenderer from './subcomponents/ToolsRenderer';


const QuickAccessGrid = ({ searchQuery, data }) => {
  const gridRef = useRef<any>(null);
  const containerStyle = useMemo(() => ({ width: "100%", height: "70vh" }), []);
  const gridStyle = useMemo(() => ({ height: '70vh', width: "100%" }), []);
  const [rowData, setRowData] = useState(data)

  const [columnDefs, setColumnDefs] = useState<any>([
    { headerName: "Category", field: "category", headerTooltip: "category", rowGroup: true, hide: true },
    { field: 'tools', cellRenderer: ToolsRenderer }
  ])


  useEffect(() => {
    if (searchQuery.length > 0) {
      const filteredData = data.map(row => ({
        ...row,
        tools: row.tools.filter(tool => 
          tool.name.toLowerCase().includes(searchQuery.toLowerCase()) || 
          tool.url.toLowerCase().includes(searchQuery.toLowerCase())
        )
      })).filter(row => row.tools.length > 0);
  
      setRowData(filteredData);
    } else {
      setRowData(data);
    }
  }, [searchQuery]);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
    };
  }, []);


  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 200,
      cellRendererParams: {
        suppressCount: true,
      }
    }
  }, [])

  const gridOptions = {
    rowHeight: 80,
    suppressContextMenu: true
  }


  return (
    <div style={containerStyle}>

      <div className="ag-theme-quartz resourcecost quick-access" style={gridStyle}>
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          groupDisplayType={"groupRows"}
          autoGroupColumnDef={autoGroupColumnDef}
          gridOptions={gridOptions}
          // groupDefaultExpanded={-1}
        />
      </div>

    </div>
  )
}

export default QuickAccessGrid;